import React, { useState } from "react";
import axios from "axios";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import LoadingPopup from "../../SharedView/LoadingPopup";
import "./addClientUserModal.css";

function AddClientUserModal({ clientId, onClose, onUserAdded }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!firstName || !lastName || !email || !phoneNumber) {
            setFeedbackMessage("All fields are required.");
            setShowPopup(true);
            return;
        }

        setIsProcessing(true);
        setFeedbackMessage("");
        setShowPopup(false);

        try {
            const response = await axios.post(`/api/users/clients/${clientId}/`, {
                first_name: firstName,
                last_name: lastName,
                email: email.trim().toLowerCase(),
                phone_number: phoneNumber
            });

            setFeedbackMessage("User added successfully.");
            onUserAdded(response.data.user); // Refresh user list
            setShowPopup(true);
        } catch (error) {
            console.error("Error adding user:", error);
            const serverError = error.response?.data?.error;

            if (error.response?.status === 400 && serverError) {
                if (serverError === "Email is already in use") {
                    setFeedbackMessage("Email is already in use. Please use a different email.");
                } else if (serverError.toLowerCase().includes("phone")) {
                    // e.g. "This phone number is already in use by another account."
                    setFeedbackMessage(serverError);
                } else {
                    setFeedbackMessage(serverError);
                }
            } else {
                setFeedbackMessage("Failed to add user. " + error.message);
            }

            setShowPopup(true);
        } finally {
            setIsProcessing(false);
        }
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        if (feedbackMessage === "User added successfully.") {
            onClose();
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button type="button" className="modal-x" onClick={onClose}>&times;</button>
                <h3>Add New Client User</h3>
                <form onSubmit={handleSubmit}>
                    <label>First Name</label>
                    <input
                        type="text"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        placeholder="Enter first name"
                        required
                    />

                    <label>Last Name</label>
                    <input
                        type="text"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        placeholder="Enter last name"
                        required
                    />

                    <label>Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter email address"
                        required
                    />

                    <label>Phone Number</label>
                    <PhoneInput
                        defaultCountry="ae"
                        value={phoneNumber}
                        onChange={(value) => setPhoneNumber(value)}
                        placeholder="Enter phone number"
                        className="client-user-modal-phone-wrapper"
                        inputClassName="client-user-modal-phone-input"
                    />

                    <div className="add-user-modal-actions">
                        <button type="submit" className="save-button">Add User</button>
                    </div>
                </form>
            </div>
            {showPopup && (
                <LoadingPopup
                    isLoading={isProcessing}
                    feedbackMessage={feedbackMessage}
                    onClose={handleClosePopup}
                />
            )}
        </div>
    );
}

export default AddClientUserModal;
